// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"79bb43ef","425":"d0e29a88","510":"fc0d569d","532":"414d80e7","633":"d0e6fa2c","634":"59bec93a","922":"1a0ed3ef","937":"0457f0bc","972":"a17407fb"}[chunkId] + ".chunk.js";
};